import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState, useMemo} from "react";
import {retainActions} from "../../../../../../_actions";
import {RetainCampaignBuilder} from "../objects/RetainCampaignBuilder";
import _ from "lodash";
import {formatProactiveMetric} from "../../../Proactive/Utilities/CampaignUtils";
import {buildMetricsDetailsUrl, formatCurrency, formatRevenue, RETAIN_CAMPAIGNS} from "../CampaignUtils";
import moment from "moment";
import CampaignActions from "components/v2/views/ProactiveMetricsDetail/Utilities/CampaignActions";

export default function (customParams) {
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const { organization_id = '' } = JSON.parse(localStorage.user);
    const params = {
        startDate: customParams?.startDate || moment().subtract(2, 'years').startOf('day').toISOString(),
        endDate: customParams?.endDate || moment().endOf('day').toISOString(), // Current date, end of day
    };

    useEffect(() => {
        if(customParams) {
            if(customParams.organizationId){
                dispatch(retainActions.getOrganizationRetainCampaigns(customParams.organizationId, params));
            }
        } else {
            dispatch(retainActions.getCompanyRetainCampaigns())
        }
    }, [customParams?.refreshTrigger]);

    const retainCampaigns = useSelector(state => state.retain);
    const loading = retainCampaigns.loadingRetainCampaign;
    const campaignsObj = retainCampaigns.retainCampaigns;
    const campaignList = _.get(campaignsObj, 'items') || [];
    const totalCount = _.get(campaignsObj, 'totalCount') || 0;
    const rows = [];

    if(!loading && campaignList.length > 0) {
        campaignList.map( item => {
            const {campaign, metrics} = item;
            const builder = new RetainCampaignBuilder()

            builder.setId(_.get(campaign, 'id') || '-');
            builder.setName(_.get(campaign, 'name') || '-');
            builder.setConversations(_.get(metrics, 'conversations') || '-');
            builder.setRevenue(formatRevenue(_.get(metrics, 'revenue.amount')));
            builder.setRevenuePerRecipient(formatCurrency(_.get(metrics, 'revenuePerRecipient.amount')));
            builder.setAverageOrderValue(formatCurrency(_.get(metrics, 'averageOrderValue.amount')));
            builder.setConversionRate(_.get(metrics, 'conversionRate') || '-');
            builder.setOrders(_.get(metrics, 'orders') || '-');
            if(customParams) builder.setActions(<CampaignActions campaign={builder.campaign} />)

            builder.setParam(buildMetricsDetailsUrl({
                id: _.get(campaign, 'id'),
                source: _.get(campaign, 'source'),
                organizationId:customParams ? customParams.organizationId : organization_id
                }, RETAIN_CAMPAIGNS, params))
            ;

            rows.push(builder.campaign);
        })
    }

    const paginatedRows = useMemo(() => {
        return rows.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    }, [rows, page]);

    const changePage = (nextPage) => {
        setPage(nextPage)
    }

    const baseColumns = [
        {
            id: 'name',
            label: 'Campaign',
            width: 170,
            clickable: true,
            isSortable: true,
            withTooltip: true,
        },
        {
            id: 'conversations',
            label: 'Conversations',
            width: 100,
            isSortable: true,
            align: 'right',
            format: (value) => value.toLocaleString('en-US'),
        },
        {
            id: 'revenue',
            label: 'Revenue',
            width: 100,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'revenuePerRecipient',
            label: 'Revenue Per Recipient',
            width: 170,
            clickable: true,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'averageOrderValue',
            label: 'Average Order Value',
            width: 100,
            isSortable: true,
            align: 'right',
        },
        {
            id: 'conversionRate',
            label: 'Conversion Rate',
            width: 100,
            isSortable: true,
            align: 'right',
            format: formatProactiveMetric,
        },
        {
            id: 'orders',
            label: 'Orders',
            width: 100,
            isSortable: true,
            align: 'right',
        },
    ];
    const columns = !customParams ? baseColumns : [
        ...baseColumns,
        {
            id: 'actions',
            label: 'Actions',
            width: 30,
            align: 'right',
        }
    ];

    return { rows: paginatedRows, columns, totalCount, loading, changePage, page };
}
